import { safeLocalStorage } from "../services/utils";

const SUPPORTED_LANGUAGES = ["ar", "en", "fr"];
export const getUserLanguage = () => {
  // get lang param value and check if it is valid
  const urlParams = new URLSearchParams(window.location.search);
  const langParamValue = urlParams.get("lang")?.toLowerCase() || "";

  const URLLangSelected = SUPPORTED_LANGUAGES.includes(langParamValue)
    ? langParamValue
    : undefined;

  // get lang value from localStorage and check if it is valid
  const storageLangValue = safeLocalStorage.getItem("mh__language__") || "";
  const storageLangSelected = SUPPORTED_LANGUAGES.includes(storageLangValue)
    ? storageLangValue
    : undefined;

  // get lang value from browser and check if it is valid
  const browserLangValue = navigator.language?.substring(0, 2);
  const browserLangSelected = SUPPORTED_LANGUAGES.includes(browserLangValue)
    ? browserLangValue
    : undefined;

  return URLLangSelected || storageLangSelected || browserLangSelected || "en";
};
